import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components";
import { Toggle } from "@/components/Toggle/Toggle";
import { Information } from "@/components/Information/Information";

interface ActivateListModalProps {
	isOpen: boolean;
	activateCampaign: boolean;
	onClose: () => void;
	onActivate: () => void;
	onGoToLists: () => void;
	onToggleActivateCampaign: () => void;
}

export const ActivateListModal: FunctionComponent<ActivateListModalProps> = ({
	isOpen,
	activateCampaign,
	onClose,
	onActivate,
	onGoToLists,
	onToggleActivateCampaign,
}) => {
	const { t } = useTranslation();
	const tsSettings = (key: string) => t(`list.settings.${key}`);

	if (!isOpen) {
		return null;
	}

	return (
		<Modal
			handleClose={onClose}
			handleSave={onActivate}
			handleSecondSave={onGoToLists}
			isOpened={isOpen}
			secondSubmitButtonText={tsSettings("goToListsButton")}
			size="xs"
			submitButtonText={tsSettings("activateListButton")}
			title={tsSettings("activateListTitle")}
		>
			<div className="flex flex-col gap-4">
				<div className="text-sm">
					<p>{tsSettings("activateListDescription1")}</p>
					<br />

					<p>{tsSettings("activateListDescription2")}</p>
					<br />
					<div className="flex flex-row items-center gap-4">
						<Toggle
							isChecked={activateCampaign}
							name="activateCampaign"
							onChange={onToggleActivateCampaign}
						/>
						<span className="text-sm text-text-meta">
							{tsSettings("activateOutreachLabel")}{" "}
							<Information information={tsSettings("activateOutreachInfo")} />
						</span>
					</div>
				</div>
			</div>
		</Modal>
	);
};
